import { render } from "./BookMark.vue?vue&type=template&id=ec72a158&scoped=true"
import script from "./BookMark.vue?vue&type=script&lang=js"
export * from "./BookMark.vue?vue&type=script&lang=js"

import "./BookMark.vue?vue&type=style&index=0&id=ec72a158&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec72a158"]])

export default __exports__